import { withWidth } from '@material-ui/core';
import { Container, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
    textAlign: 'center',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
  glow: {
    textShadow: '0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12',
  },
}));

const Copy1A = ({ width }) => {
  const classes = useStyles();

 

  return (
    <Container>
      <div
        id="Copy1AA"
        style={{ margin: `${window.innerHeight / 5}px auto ${window.innerHeight / 3}px` }}
      >
        <Typography
          className={classes.textMonarcha}
          sx={{ color: '#ffbf12', fontSize: width === 'xs' ? '1.65rem' : '' }}
          variant="h3"
        >
          Content creators <br />
          <span style={{ color: '#fff' }}> lacking</span> {width === 'xs' && <br />}future financial
          security
          <br />
          <br />
          —PassionStocks{width === 'xs' && <br />} was built for you.
        </Typography>
      </div>
    </Container>
  );
};
export default withWidth()(Copy1A);
